import {Component, ElementRef, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {register} from 'swiper/element/bundle';
import {ModalPageController} from '../../Core/page-controller/modal-page-controller';

register();

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.page.html',
  styleUrls: ['./gallery.page.scss'],
  standalone: false
})
export class GalleryPage extends ModalPageController implements OnInit {

  @ViewChild('swiperRef') swiperRef!: ElementRef;

  @Input() images: string[] = [];

  rotations: number[] = [];
  perpendicular: boolean[] = [];

  constructor(
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    this.initImageStates();
  }


  /**
   * Inicializar estados de las imágenes
   *
   */
  initImageStates() {
    this.rotations = this.images.map(() => 0);
    this.perpendicular = this.images.map(() => false);
  }


  /**
   * Rotar la imagen
   *
   */
  rotateImage(direction: 'left' | 'right') {
    const swiper = this.swiperRef?.nativeElement?.swiper;
    const index: number = swiper?.activeIndex ?? 0;

    if (swiper?.zoom) {
      swiper.zoom.out();
    }

    this.rotations[index] += direction === 'right' ? 90 : -90;

    const normalized = ((this.rotations[index] % 360) + 360) % 360;
    this.perpendicular[index] = normalized === 90 || normalized === 270;
  }

}
